import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Title from '../general/util/Title'
import HTML from '@otavamedia/om-component-library/lib/util/HTML'
import { NavLink } from '../general/util/Links'
import { ArrowRightPrimaryIcon } from '../widgets/Icons'
import '../navigation/WeeklyMagazineContentsMenu.scss'
import track from 'react-tracking'

/**
 * TVTM Table Of Contents component
 **/
class TableOfContents extends Component {
  renderVignetteAndTopic = item => {
    if (item.isEquation) {
      return <span styleName="vignette">Puheenaihe </span>
    }

    if (item.vignette && item.topic) {
      return (
        <Fragment>
          <span styleName="vignette"><HTML>{item.vignette}</HTML> </span>
          <span><HTML>{item.topic}</HTML> &mdash; </span>
        </Fragment>
      )
    } else if (item.vignette && !item.topic) {
      return <span styleName="vignette"><HTML>{item.vignette}</HTML> </span>
    } else {
      return null
    }
  }

  render () {
    const { onDarkBackground } = this.props
    if (!this.props.contents || !this.props.contents[0]) {
      return null
    }
    return this.props.contents.map((section, index) => (
      <Fragment key={`section-${index}`}>
        <Fragment>
          {index === 0 && !section.title && this.props.addMainSectionTitle
            ? <Title key="main-items-title" text="Pääjutut" />
            : section.title ? <Title text={section.title} /> : null
          }
          <ul styleName={onDarkBackground ? 'toc-list dark' : 'toc-list'}>
            {section.articles.map((item) => {
              return (
                <li styleName="article-link" key={`toc-item-${item.link}`}>
                  <NavLink to={item}>
                    <ArrowRightPrimaryIcon />
                    <span styleName="title">{this.renderVignetteAndTopic(item)}<HTML>{item.title}</HTML></span>
                  </NavLink>
                </li>
              )
            })}
          </ul>
        </Fragment>
      </Fragment>
    ))
  }
}

TableOfContents.propTypes = {
  contents: PropTypes.array.isRequired,
  addMainSectionTitle: PropTypes.bool,
  onDarkBackground: PropTypes.bool,
}

export default track({ gtmContext: ['TableOfContents'] })(TableOfContents)
